'use client'

import type { Annotation, Annotation2 } from '@/types/annotation'

/**
 * TimeAnnotation
 *
 * Renders the current time tool result as a card (time, date, location).
 */

export function TimeAnnotation({ annotation }: { annotation: Annotation | Annotation2 }) {
  const raw = (annotation as Record<string, unknown>).currentTime__getCurrentTime
  if (!raw) return null

  const data =
    typeof raw === 'object' && raw !== null && 'result' in raw
      ? (raw as { result: { time?: string; date?: string; timezone?: string; city?: string; formatted?: string } })
          .result
      : (raw as { time?: string; date?: string; timezone?: string; city?: string; formatted?: string })

  if (!data?.time) return null

  const location = data.city || data.timezone || undefined

  return (
    <div className="bg-muted/40 text-foreground border-border/50 rounded-xl border p-4 shadow-sm">
      <div className="flex flex-col gap-1">
        <div className="text-2xl font-semibold tabular-nums">{data.time}</div>
        {data.date && (
          <div className="text-sm opacity-90">
            {data.date}
            {data.timezone && (
              <span className="text-muted-foreground ml-1">({data.timezone})</span>
            )}
          </div>
        )}
        {location && (
          <div className="text-muted-foreground mt-0.5 text-xs">{location}</div>
        )}
      </div>
    </div>
  )
}
